import { TableFooter } from '@fukuri-admins/features/Table/TableFooter/index.tsx';
import { TableSearch } from '@fukuri-admins/ui/common';
import { CircularProgress } from '@mui/material';
import { ClientAdminUserTableContent } from '../../../components/clientAdminUser/ClientAdminUserTableContent/index.tsx';
import { ClientAdminUserTableFilter } from '../../../components/clientAdminUser/ClientAdminUserTableFilter/index.tsx';
import { ContentsHeader } from '../../../components/common/ContentsHeader/index.tsx';
import { ClientAdminUserType } from '../../../types/resources/ClientAdminUserType.ts';
import { ActionTableColumnsType } from '../../../types/table/ActionTableColumnsType.ts';
import { ActionTableSortParamsType } from '../../../types/table/ActionTableSortParamsType.ts';
import { handleSorting } from '../../../utils/sortings.ts';
import styles from './styles.module.scss';

type IntegratedClientAdminUserListProps = {
  filteredClientAdminUsers: ClientAdminUserType[];
  setFilteredClientAdminUsers: (users: ClientAdminUserType[]) => void;
  isLoading: boolean;
  sortParams: ActionTableSortParamsType;
  setSortParams: (params: ActionTableSortParamsType) => void;
  handlePageChange: (page: number) => void;
  totalCount: number;
  totalPage: number;
  onSearch: () => void;
  onClear: () => void;
};

export const IntegratedClientAdminUserList = ({
  filteredClientAdminUsers,
  setFilteredClientAdminUsers,
  isLoading,
  sortParams,
  setSortParams,
  handlePageChange,
  totalCount,
  totalPage,
  onSearch,
  onClear,
}: IntegratedClientAdminUserListProps) => {
  const tableHeader: ActionTableColumnsType[] = [
    {
      label: '利用企業名',
      key: 'client.name',
      sortable: true,
      filterable: true,
    },
    { label: '氏名', key: 'full_name', sortable: true, filterable: true },
    {
      label: 'メールアドレス',
      key: 'email',
      sortable: true,
      filterable: true,
    },
    {
      label: '作成日時',
      key: 'created_at',
      sortable: true,
      filterable: false,
    },
  ];

  return (
    <div className={styles.Root} data-testid='client-admin-page'>
      <ContentsHeader
        title='利用企業管理者一覧'
        description='利用企業管理者の一覧を表示しています。'
      />
      <div className={styles.tableContainer}>
        <div className={styles.Root__Table}>
          <div className={styles.searchContainer}>
            <TableSearch onSearch={onSearch} onClear={onClear}>
              <ClientAdminUserTableFilter />
            </TableSearch>
          </div>
          {isLoading ? (
            <div className={styles.loading}>
              <CircularProgress size='1rem' color='inherit' />
            </div>
          ) : (
            <>
              <ClientAdminUserTableContent
                rows={filteredClientAdminUsers}
                columns={tableHeader}
                sortParams={sortParams}
                headerSort={column =>
                  handleSorting(
                    column,
                    sortParams,
                    filteredClientAdminUsers,
                    setSortParams,
                    setFilteredClientAdminUsers
                  )
                }
              />
              <TableFooter
                onPageChange={handlePageChange}
                totalCount={totalCount}
                totalPage={totalPage}
                itemCount={filteredClientAdminUsers.length}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
